module.exports = [{
      plugin: require('/codebuild/output/src2132550798/src/qvrbx-website/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"QVR Software","short_name":"QVR","start_url":"/","background_color":"#fafafa","theme_color":"#21CE99","display":"standalone","icon":"src/images/icon.png"},
    },{
      plugin: require('/codebuild/output/src2132550798/src/qvrbx-website/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
